import { Injectable } from '@angular/core';
import { DataPoint } from '../graphic.point.calculator/data.point';
import { ServiceContinuityGraphicPointCalculator } from '../graphic.point.calculator/service.continuity.graphic.point.calculator';
import { VoipGraphicPointCalculator } from '../graphic.point.calculator/voip.graphic.point.calculator';
import { DefaultGraphicPointResultFormater } from '../graphic.point.calculator/graphicpointresultformater/default.graphic.point.result.formater';
import { isEmpty } from 'lodash';

@Injectable()
export class GraphicPointCalculatorService {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  get maxAllowedGap() {
    return 2;
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  formatData(rawData, reverseYAxis: boolean = false) {
    if (isEmpty(rawData)) {
      return [];
    }

    const dataPoints: Array<DataPoint> = this.transform(rawData.datapoints);
    const dataPoints1: Array<DataPoint> = this.transform(rawData.datapoints1);
    const threshold1: Array<DataPoint> = this.transform(rawData.threshold1);
    const threshold2: Array<DataPoint> = this.transform(rawData.threshold2);

    const calculator = reverseYAxis
      ? new ServiceContinuityGraphicPointCalculator(
          dataPoints,
          dataPoints1,
          threshold2,
          threshold1,
          new DefaultGraphicPointResultFormater(),
          rawData.aggregationRange,
          this.maxAllowedGap
        )
      : new VoipGraphicPointCalculator(
          dataPoints,
          dataPoints1,
          threshold1,
          threshold2,
          new DefaultGraphicPointResultFormater(),
          rawData.aggregationRange,
          this.maxAllowedGap
        );
    return calculator.getProcessedResult();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  transform(array: any): Array<DataPoint> {
    //todo: there must be a better way to this conversion so could work
    const points: Array<DataPoint> = [];
    array?.forEach(point =>
      points.push(new DataPoint(point.x, point.y, null, point?.additionalTooltip))
    );
    return points;
  }
}
